const formatYen = Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY" });

export const formatPrice = (price: number): string => {
  return formatYen.format(price);
};
